import styled from "styled-components";

const DotWrapper = styled.button`
  width: 100px;
  height: 70px;
  padding: 100px 70px;
  background-color: transparent;
  border: none;


  cursor: pointer;
  all: unset;

  /* border: 2px solid yellow; */
  display: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

export default DotWrapper;
